import '@/echarts-init.js'

import { assertApiOriginConfigured } from '@/config/env.js'
import { loadRuntimeConfig } from '@/config/loadRuntimeConfig.js'
import { initPerfLogging } from '@/utils/perfLogging.js'

initPerfLogging()

const CHUNK_RELOAD_KEY = 'stockstars:chunkReloadAt'
const CHUNK_RELOAD_COOLDOWN_MS = 10_000

// A tab opened before a deploy references hashed chunks the new deploy removed.
window.addEventListener('vite:preloadError', (event) => {
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)

  if (Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
    return
  }

  event.preventDefault()
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  window.location.reload()
})

async function bootstrap() {
  await loadRuntimeConfig()
  if (import.meta.env.PROD) {
    assertApiOriginConfigured()
  }
  const { bootstrapVueApp } = await import('@/bootstrap.js')
  await bootstrapVueApp()
}

bootstrap().catch((err) => {
  console.error(err)
  document.body.innerHTML = '<div class="app-boot-splash" role="alert">' +
    '<p class="app-boot-splash__logo">StockStars</p>' +
    '<p class="app-boot-splash__logo" style="font-size:1rem;font-weight:400">' +
    'Failed to load application configuration.</p>' +
    '</div>'
})
